import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { StyleSheetManager } from 'styled-components'
import './App.css'
import { Demo } from './Demo/Demo'
import { Departure } from './Departure/Departure'
import Emergency from './Emergency'
import ImportExport from './ImportExport'
import { Instructions } from './Instructions/Instructions'
import { LanguageSelection } from './LanguageSelection/LanguageSelection'
import { MapContainer } from './Map/MapContainer'
import { NoPhotos } from './NoPhotos/NoPhotos'
import SimpleMap from './SimpleMap/SimpleMap'
import Start from './Start/Start'
import TimetableFlat from './TimetableFlat'
import Switcher from './TimetableList/Switcher'
import { Config } from './const'
import { isIOS } from './helper/userAgents'
import { checkSavedFilterValues } from './state/filter/filterSlice'
import { LangProvider } from './state/language'
import { store } from './state/store'
import { timetableActions } from './state/timetable/timetableSlice'

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`)

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const vh = window.innerHeight * 0.01

  console.log('resize', {
    vh,
    height: window.innerHeight,
    width: window.innerWidth,
  })

  // on IOS installed as app, the height is not correct, width and height are both the same
  if (window.innerWidth !== window.innerHeight) {
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  // on ios we need to wait a bit longer to get the new height
  setTimeout(() => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const vh = window.innerHeight * 0.01

    console.log('resize after timeout', {
      vh,
      height: window.innerHeight,
      width: window.innerWidth,
    })
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, 300)
})

document.addEventListener('DOMContentLoaded', () => {
  // we can move only if we are not in a browser's tab
  const isBrowser = matchMedia('(display-mode: browser)').matches
  if (!isBrowser) {
    window.moveTo(16, 16)
    window.resizeTo(600, 800)
  }

  const isStandalone = matchMedia('(display-mode: standalone)').matches
  const isFullscreen = matchMedia('(display-mode: fulscreen)').matches

  if (isIOS && (isStandalone || isFullscreen)) {
    document.body.classList.add('ios-standalone')
  }
})

const App = () => {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('App startet. Version: ' + Config.VERSION)
    store.dispatch(checkSavedFilterValues())
  }, [])

  useEffect(() => {
    const loadTimetable = async () => {
      store.dispatch(timetableActions.setLoading(true))

      import('./artists.json')
        .then((m) => m.default)
        .then((loadedArtists) => {
          // eslint-disable-next-line no-console
          console.log('Artists loaded')

          const artists = loadedArtists
          store.dispatch(timetableActions.setArtists(artists))
        })
    }

    loadTimetable()
  }, [])

  return (
    <div className="App">
      <LangProvider>
        <Provider store={store}>
          <StyleSheetManager
            shouldForwardProp={(prop) =>
              ![
                'isFavorite',
                'activeDay',
                'isSticky',
                'marginRight',
                'alignItems',
                'flexDirection',
                'gradientType',
                'white',
                'isActive',
                'isFirst',
                'withBackground',
                'alignLeft',
                'withSolidBackground',
                'isVisible',
                'center',
                'mr',
                'ml',
                'justifyContent',
                'isLast',
                'hasEvent',
                'isCurrent',
                'isEven',
                'isCurrentTimeColumn',
              ].includes(prop)
            }
          >
            <HashRouter>
              <Routes>
                <Route path="/" element={<LanguageSelection />} />
                <Route path="/import/:code" element={<LanguageSelection />} />
                <Route path="start" element={<Start />} />
                <Route path="instructions" element={<Instructions />} />
                <Route path="no-photos" element={<NoPhotos />} />

                {!Config.REACT_APP_SHOW_NOT_REALEASED && (
                  <>
                    <Route
                      path="/timetable"
                      element={<Switcher type="timetable" />}
                    />

                    <Route
                      path="/timetable-flat"
                      element={<TimetableFlat showFilterButton={true} />}
                    />

                    <Route
                      path="/favorites"
                      element={<Switcher type="favorites" />}
                    />
                    <Route path="/notfall" element={<Emergency />} />
                    <Route path="/importExport" element={<ImportExport />} />

                    <Route path="/demo" element={<Demo />} />

                    {/* {Config.REACT_APP_SHOW_DEPARTURE && ( */}
                    <Route path="/departure" element={<Departure />} />
                    {/* )} */}
                    {Config.REACT_APP_SHOW_MAP &&
                      Config.REACT_APP_IS_FUSION && (
                        <Route
                          path="/map/:filter?"
                          element={<MapContainer />}
                        />
                      )}

                    {Config.REACT_APP_SHOW_MAP &&
                      !Config.REACT_APP_IS_FUSION && (
                        <Route path="/map" element={<SimpleMap />} />
                      )}
                  </>
                )}
              </Routes>
            </HashRouter>
          </StyleSheetManager>
        </Provider>
      </LangProvider>
    </div>
  )
}

export default App
